import React, { useEffect, useState } from "react";
import {
  fetchVenues, createVenue, deleteVenue,
  fetchEvents, fetchEvent, createEvent, updateEvent, deleteEvent,
  addEventCharge, deleteEventCharge, fetchCompanies, fetchEventPackages,
  fetchBlocks, getCurrency, getRole,
} from "../services/api";
import { formatPrice } from "../utils/currency";
import { useT } from "../i18n/useT";

// Front Desk — Phase C1: events & banquets. Book halls for weddings,
// conferences, private dinners and corporate functions; each event carries a
// folio (covers x rate + extras -> service charge + VAT, less deposit).
const S = {
  en: {
    title: "Events & banquets", subtitle: "Functions in a hall — meetings, weddings, conferences",
    newEvent: "New event", venues: "Halls & venues", from: "From", to: "To", all: "All",
    board: "Board", listView: "List", unassigned: "Unassigned",
    title_f: "Event title", type: "Type", venue: "Venue", date: "Date", start: "Start", end: "End",
    covers: "Covers", rate: "Rate / cover", deposit: "Deposit", company: "Bill to company", none: "None",
    contact: "Contact name", phone: "Phone", email: "Email", status: "Status", save: "Save",
    cancel: "Cancel", create: "Create event", noEvents: "No events in this range.",
    folio: "Folio", coversTotal: "Covers", extras: "Extras", service: "Service charge", tax: "Tax",
    total: "Total", paid: "Deposit + paid", balance: "Balance", addCharge: "Add charge", label: "Label",
    amount: "Amount", qty: "Qty", kind: "Kind", del: "Delete", delEvent: "Delete event",
    venueName: "Hall name", capacity: "Capacity", rental: "Default rental", addVenue: "Add hall",
    pax: "pax", confirmDel: "Delete this event and its folio?", confirmVenue: "Remove this hall?",
    pkg: "Package", pkgNone: "No package", included: "Included", printBeo: "Print BEO",
    beoTitle: "Banquet Event Order", notes: "Notes", catering: "Catering",
    partOfGroup: "Part of group (room block)", groupNone: "— none —",
    consolidatedNote: "This function is on the group's consolidated master bill.",
    edit: "Edit",
  },
  am: {
    title: "ዝግጅቶች እና ግብዣዎች", subtitle: "በአዳራሽ የሚደረጉ ዝግጅቶች — ስብሰባዎች፣ ሠርግ፣ ኮንፈረንስ",
    newEvent: "አዲስ ዝግጅት", venues: "አዳራሾች", from: "ከ", to: "እስከ", all: "ሁሉም",
    board: "ሰሌዳ", listView: "ዝርዝር", unassigned: "ያልተመደበ",
    title_f: "የዝግጅት ርዕስ", type: "ዓይነት", venue: "አዳራሽ", date: "ቀን", start: "ጀምር", end: "ጨርስ",
    covers: "ሰዎች", rate: "ዋጋ / ሰው", deposit: "ቅድሚያ ክፍያ", company: "ለድርጅት አስከፍል", none: "የለም",
    contact: "የተጠሪ ስም", phone: "ስልክ", email: "ኢሜይል", status: "ሁኔታ", save: "አስቀምጥ",
    cancel: "ሰርዝ", create: "ዝግጅት ፍጠር", noEvents: "በዚህ ክልል ዝግጅት የለም።",
    folio: "ሒሳብ", coversTotal: "ሰዎች", extras: "ተጨማሪ", service: "የአገልግሎት ክፍያ", tax: "ታክስ",
    total: "ጠቅላላ", paid: "ቅድሚያ + የተከፈለ", balance: "ቀሪ", addCharge: "ክፍያ ጨምር", label: "መለያ",
    amount: "መጠን", qty: "ብዛት", kind: "ዓይነት", del: "ሰርዝ", delEvent: "ዝግጅት ሰርዝ",
    venueName: "የአዳራሽ ስም", capacity: "አቅም", rental: "ነባሪ ኪራይ", addVenue: "አዳራሽ ጨምር",
    pax: "ሰው", confirmDel: "ይህን ዝግጅት ከሒሳቡ ጋር ይሰረዝ?", confirmVenue: "ይህ አዳራሽ ይወገድ?",
    pkg: "ጥቅል", pkgNone: "ጥቅል የለም", included: "የተካተተ", printBeo: "BEO አትም",
    beoTitle: "የዝግጅት ትዕዛዝ", notes: "ማስታወሻ", catering: "ምግብ አቅርቦት",
    partOfGroup: "የቡድን አካል (የክፍል ብሎክ)", groupNone: "— የለም —",
    consolidatedNote: "ይህ ዝግጅት በቡድኑ የተጠቃለለ ዋና ሒሳብ ላይ ነው።",
    edit: "አስተካክል",
  },
  om: {
    title: "Sagantaalee fi cidha", subtitle: "Sagantaalee galma keessatti — walgahii, cidha, konfaransii",
    newEvent: "Sagantaa haaraa", venues: "Galmawwan", from: "Irraa", to: "Hamma", all: "Hunda",
    board: "Gabatee", listView: "Tarree", unassigned: "Hin ramadamne",
    title_f: "Mata-duree sagantaa", type: "Gosa", venue: "Galma", date: "Guyyaa", start: "Jalqaba", end: "Xumura",
    covers: "Namoota", rate: "Gatii / nama", deposit: "Kaffaltii duraa", company: "Dhaabbataaf galchi", none: "Hin jiru",
    contact: "Maqaa qunnamtii", phone: "Bilbila", email: "Imeelii", status: "Haala", save: "Olkaa'i",
    cancel: "Haqi", create: "Sagantaa uumi", noEvents: "Daangaa kana keessa sagantaan hin jiru.",
    folio: "Herrega", coversTotal: "Namoota", extras: "Dabalata", service: "Kaffaltii tajaajilaa", tax: "Gibira",
    total: "Ida'ama", paid: "Duraa + kaffalame", balance: "Hafe", addCharge: "Kaffaltii dabali", label: "Maqaa",
    amount: "Hanga", qty: "Baay'ina", kind: "Gosa", del: "Haqi", delEvent: "Sagantaa haqi",
    venueName: "Maqaa galmaa", capacity: "Dandeettii", rental: "Kiraa idilee", addVenue: "Galma dabali",
    pax: "nama", confirmDel: "Sagantaa kana herrega isaa waliin haquu?", confirmVenue: "Galma kana haquu?",
    pkg: "Paakejii", pkgNone: "Paakejii hin jiru", included: "Kan hammate", printBeo: "BEO maxxansi",
    beoTitle: "Ajaja Sagantaa", notes: "Yaadannoo", catering: "Nyaata",
    partOfGroup: "Kutaa garee (blokii kutaa)", groupNone: "— hin jiru —",
    consolidatedNote: "Sagantaan kun herrega guddaa garee walitti qabame irra jira.",
    edit: "Gulaali",
  },
};

const CARD = { background: "#fff", border: "1px solid #eef2f2", borderRadius: 14, boxShadow: "0 1px 3px rgba(6,59,72,0.06)" };
const EVENT_TYPES = ["wedding", "conference", "private", "corporate", "other"];
const STATUSES = ["inquiry", "tentative", "confirmed", "running", "closed", "cancelled"];
const CHARGE_KINDS = ["extra", "rental", "decor", "drinks", "av", "package"];
const STATUS_COLOR = {
  inquiry: "#8A5A0B", tentative: "#8A5A0B", confirmed: "#0F6E56",
  running: "#185FA5", closed: "#5b6472", cancelled: "#A32D2D",
};
const iso = (off) => { const d = new Date(); d.setDate(d.getDate() + off); return d.toISOString().slice(0, 10); };
const inp = { padding: 8, borderRadius: 8, border: "1px solid #d8dee2", fontSize: 13.5, boxSizing: "border-box" };
const lbl = { fontSize: 12, color: "#5f6b78", display: "block", marginBottom: 3 };
// Grid form helpers — `cell` lets each column shrink (min-width:0) so long
// <select> option text can't blow the column out and overlap its neighbour;
// `field` makes every control fill its own cell instead of sizing to content.
const cell = { minWidth: 0 };
const field = { ...inp, width: "100%" };
// Board (hall availability) helpers.
const WD = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
const enumDays = (f, tt) => {
  const out = []; const s = new Date(f); const e = new Date(tt);
  for (let i = 0; i < 31; i++) { const d = new Date(s); d.setDate(s.getDate() + i); if (d > e) break; out.push(d.toISOString().slice(0, 10)); }
  return out;
};
const fmtDay = (s) => `${WD[new Date(s).getDay()]} ${s.slice(8, 10)}/${s.slice(5, 7)}`;
const bhead = { border: "1px solid #eef2f2", padding: "4px 6px", background: "#F7FAF9", fontWeight: 600, color: "#5b6472", whiteSpace: "nowrap", fontSize: 11.5 };
const bcell = { border: "1px solid #eef2f2", padding: "3px 4px", verticalAlign: "top", minWidth: 88 };

export default function EventsPage() {
  const { lang } = useT();
  const t = (k) => (S[lang] && S[lang][k]) || S.en[k] || k;
  const cur = getCurrency() || "ETB";
  const isManager = getRole() === "manager";
  // Front desk can set up halls too (a small hotel's receptionist does the setup).
  const canManageVenues = isManager || getRole() === "front_desk";

  const [venues, setVenues] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [packages, setPackages] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [events, setEvents] = useState([]);
  const [from, setFrom] = useState(iso(-7));
  const [to, setTo] = useState(iso(120));
  const [status, setStatus] = useState("");
  const [sel, setSel] = useState(null);        // selected event detail
  const [showForm, setShowForm] = useState(false);
  const [showVenues, setShowVenues] = useState(false);
  const [showBoard, setShowBoard] = useState(false);
  const blankForm = { title: "", event_type: "wedding", venue_id: "", package_id: "", event_date: iso(14), start_time: "", end_time: "", covers: "", rate_per_cover: "", deposit: "", company_account_id: "", block_id: "", contact_name: "", phone: "", email: "", status: "inquiry", notes: "" };
  const [form, setForm] = useState(blankForm);
  const [vf, setVf] = useState({ name: "", kind: "hall", capacity: "", rental: "" });
  const [cf, setCf] = useState({ kind: "extra", label: "", qty: "1", amount: "" });
  const [err, setErr] = useState("");
  // Full event-detail edit (#9): reveal a form pre-filled from the selected event.
  const [editing, setEditing] = useState(false);
  const [eform, setEform] = useState(null);

  const loadVenues = () => fetchVenues().then(setVenues).catch(() => setVenues([]));
  const loadEvents = () => fetchEvents({ date_from: from, date_to: to, ...(status ? { status } : {}) }).then(setEvents).catch(() => setEvents([]));
  useEffect(() => {
    loadVenues();
    fetchCompanies().then(setCompanies).catch(() => setCompanies([]));
    fetchEventPackages().then(setPackages).catch(() => setPackages([]));
    fetchBlocks().then((bs) => setBlocks((bs || []).filter((b) => b.status !== "cancelled"))).catch(() => setBlocks([]));
    /* eslint-disable-next-line */
  }, []);
  useEffect(() => { loadEvents(); /* eslint-disable-next-line */ }, [from, to, status]);

  const open = (id) => fetchEvent(id).then((e) => { setSel(e); setEditing(false); }).catch(() => {});
  const startEdit = (e) => {
    setEform({
      title: e.title || "", event_type: e.event_type || "other", venue_id: e.venue_id || "",
      package_id: e.package_id || "", event_date: e.event_date || "", start_time: e.start_time || "",
      end_time: e.end_time || "", covers: e.covers != null ? String(e.covers) : "",
      rate_per_cover: e.rate_per_cover != null ? String(e.rate_per_cover) : "",
      deposit: e.folio && e.folio.deposit != null ? String(e.folio.deposit) : "",
      company_account_id: e.company_account_id || "", contact_name: e.contact_name || "",
      phone: e.phone || "", email: e.email || "", notes: e.notes || "",
    });
    setEditing(true);
  };
  const saveEdit = () => {
    const f = eform || {};
    if (!(f.title || "").trim()) { setErr("title"); return; }
    const body = {
      title: f.title.trim(), event_type: f.event_type,
      venue_id: f.venue_id ? Number(f.venue_id) : null,
      package_id: f.package_id ? Number(f.package_id) : null,
      event_date: f.event_date, start_time: f.start_time || null, end_time: f.end_time || null,
      covers: num(f.covers) || 0, rate_per_cover: num(f.rate_per_cover) || 0,
      company_account_id: f.company_account_id ? Number(f.company_account_id) : null,
      contact_name: f.contact_name || null, phone: f.phone || null, email: f.email || null,
      notes: f.notes || null,
    };
    updateEvent(sel.id, body).then((r) => { setSel(r); setEditing(false); setErr(""); loadEvents(); })
      .catch((ex) => setErr((ex.response && ex.response.data && ex.response.data.detail) || "error"));
  };
  const num = (v) => (v === "" || v == null ? undefined : Number(v));
  const blockLabel = (b) => `${b.company_name || b.name}${b.check_in_date ? ` · ${b.check_in_date}→${b.check_out_date}` : ""}`;
  const blockById = (id) => blocks.find((b) => b.id === id);

  const submitEvent = () => {
    setErr("");
    if (!form.title.trim()) { setErr("title"); return; }
    const body = {
      title: form.title.trim(), event_type: form.event_type,
      venue_id: form.venue_id ? Number(form.venue_id) : null,
      package_id: form.package_id ? Number(form.package_id) : null,
      event_date: form.event_date, start_time: form.start_time || null, end_time: form.end_time || null,
      covers: num(form.covers) || 0, rate_per_cover: num(form.rate_per_cover) || 0,
      deposit: num(form.deposit) || 0, status: form.status,
      company_account_id: form.company_account_id ? Number(form.company_account_id) : null,
      block_id: form.block_id ? Number(form.block_id) : null,
      contact_name: form.contact_name || null, phone: form.phone || null, email: form.email || null,
      notes: form.notes || null,
    };
    createEvent(body).then((e) => { setShowForm(false); setForm(blankForm); loadEvents(); open(e.id); })
      .catch((ex) => setErr((ex.response && ex.response.data && ex.response.data.detail) || "error"));
  };

  const setStatusOf = (e, st) => updateEvent(e.id, { status: st }).then((r) => { setSel(r); loadEvents(); })
    .catch((ex) => alert((ex.response && ex.response.data && ex.response.data.detail) || "error"));
  // Attach/detach this function to a group room block (0 = detach). Sending
  // block_id: 0 clears it server-side; a real id links it into the master bill.
  const setBlockOf = (e, bid) => updateEvent(e.id, { block_id: bid ? Number(bid) : 0 }).then((r) => { setSel(r); loadEvents(); })
    .catch((ex) => alert((ex.response && ex.response.data && ex.response.data.detail) || "error"));

  const removeEvent = (e) => { if (!window.confirm(t("confirmDel"))) return; deleteEvent(e.id).then(() => { setSel(null); loadEvents(); }); };

  // Banquet Event Order — a printable ops sheet the kitchen and floor work
  // from: who, when, where, how many, the catering package, and the folio.
  const printBeo = (e) => {
    const w = window.open("", "_blank", "width=820,height=920");
    if (!w) return;
    const m = (n) => formatPrice(n || 0, cur);
    const row = (k, v) => `<tr><td style="padding:4px 12px;color:#5b6472">${k}</td><td style="padding:4px 12px;font-weight:600">${v || "—"}</td></tr>`;
    const chargeRows = (e.charges || []).map((c) => `<tr><td style="padding:3px 12px">${c.kind}${c.label ? " · " + c.label : ""}</td><td style="padding:3px 12px;text-align:right">${m(c.line)}</td></tr>`).join("");
    w.document.write(
      `<html><head><meta charset="utf-8"><title>${t("beoTitle")} — ${e.title}</title></head>` +
      `<body style="font-family:Arial,Helvetica,sans-serif;color:#24313a;max-width:720px;margin:22px auto;padding:0 16px">` +
      `<h1 style="margin:0 0 2px;color:#063B48;font-size:22px">${t("beoTitle")}</h1>` +
      `<div style="color:#5b6472;font-size:13px;margin-bottom:14px">${e.title} · <b>${e.status}</b></div>` +
      `<table style="border-collapse:collapse;font-size:13px;width:100%;border:1px solid #eef2f2">` +
      row(t("type"), e.event_type) + row(t("venue"), e.venue_name) + row(t("date"), e.event_date) +
      row(t("start") + " – " + t("end"), (e.start_time || "") + " – " + (e.end_time || "")) +
      row(t("covers"), (e.covers || 0) + " " + t("pax")) +
      row(t("contact"), (e.contact_name || "") + "  " + (e.phone || "")) + `</table>` +
      (e.package_name
        ? `<h3 style="margin:16px 0 4px;color:#0F6E56;font-size:15px">${t("catering")}</h3>` +
          `<div style="font-size:13px"><b>${e.package_name}</b>${e.package_price ? " · " + m(e.package_price) + " / " + t("pax") : ""}</div>` +
          (e.package_definition ? `<div style="font-size:12.5px;color:#5b6472;margin-top:2px">${t("included")}: ${e.package_definition}</div>` : "")
        : "") +
      `<h3 style="margin:16px 0 4px;color:#0F6E56;font-size:15px">${t("folio")}</h3>` +
      `<table style="border-collapse:collapse;font-size:13px;width:100%;border:1px solid #eef2f2">` +
      `<tr><td style="padding:3px 12px">${t("coversTotal")} (${e.covers || 0} × ${m(e.rate_per_cover)})</td><td style="padding:3px 12px;text-align:right">${m(e.folio.covers_total)}</td></tr>` +
      chargeRows +
      `<tr><td style="padding:3px 12px">${t("service")}</td><td style="padding:3px 12px;text-align:right">${m(e.folio.service_charge)}</td></tr>` +
      `<tr><td style="padding:3px 12px">${e.folio.tax_label || t("tax")}</td><td style="padding:3px 12px;text-align:right">${m(e.folio.tax_amount)}</td></tr>` +
      `<tr style="border-top:1px solid #ccc;font-weight:700"><td style="padding:4px 12px">${t("total")}</td><td style="padding:4px 12px;text-align:right">${m(e.folio.total)}</td></tr>` +
      `<tr><td style="padding:3px 12px">${t("paid")}</td><td style="padding:3px 12px;text-align:right">${m(e.folio.paid)}</td></tr>` +
      `<tr style="font-weight:700"><td style="padding:3px 12px">${t("balance")}</td><td style="padding:3px 12px;text-align:right">${m(e.folio.balance)}</td></tr></table>` +
      (e.notes ? `<h3 style="margin:16px 0 4px;color:#0F6E56;font-size:15px">${t("notes")}</h3><div style="font-size:13px;white-space:pre-wrap">${e.notes}</div>` : "") +
      `</body></html>`
    );
    w.document.close();
    w.focus();
    setTimeout(() => { try { w.print(); } catch (x) { /* ignore */ } }, 350);
  };

  const submitCharge = (e) => {
    if (!cf.amount) return;
    addEventCharge(e.id, { kind: cf.kind, label: cf.label || null, qty: num(cf.qty) || 1, amount: Number(cf.amount) })
      .then((r) => { setSel(r); setCf({ kind: "extra", label: "", qty: "1", amount: "" }); loadEvents(); });
  };
  const removeCharge = (e, cid) => deleteEventCharge(e.id, cid).then((r) => { setSel(r); loadEvents(); });

  const submitVenue = () => {
    if (!vf.name.trim()) return;
    createVenue({ name: vf.name.trim(), kind: vf.kind, capacity: num(vf.capacity), rental: num(vf.rental) })
      .then(() => { setVf({ name: "", kind: "hall", capacity: "", rental: "" }); loadVenues(); });
  };
  const removeVenue = (v) => { if (!window.confirm(t("confirmVenue"))) return; deleteVenue(v.id).then(loadVenues); };

  return (
    <div style={{ maxWidth: 1040, margin: "0 auto", paddingBottom: 40 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
        <div>
          <h1 style={{ margin: "6px 0 2px" }}>{t("title")}</h1>
          <div className="muted" style={{ fontSize: 14 }}>{t("subtitle")}</div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="btn" onClick={() => setShowBoard((s) => !s)}>{showBoard ? t("listView") : t("board")}</button>
          {canManageVenues && <button className="btn" onClick={() => setShowVenues((s) => !s)}>{t("venues")}</button>}
          <button className="btn primary" onClick={() => { setShowForm((s) => !s); setErr(""); }}>+ {t("newEvent")}</button>
        </div>
      </div>

      {canManageVenues && showVenues && (
        <div style={{ ...CARD, padding: 14, marginTop: 12 }}>
          <div style={{ fontWeight: 700, marginBottom: 8 }}>{t("venues")}</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 10 }}>
            <div><label style={lbl}>{t("venueName")}</label><input style={inp} value={vf.name} onChange={(e) => setVf({ ...vf, name: e.target.value })} /></div>
            <div><label style={lbl}>{t("type")}</label>
              <select style={inp} value={vf.kind} onChange={(e) => setVf({ ...vf, kind: e.target.value })}>
                {["hall", "garden", "meeting", "other"].map((k) => <option key={k} value={k}>{k}</option>)}
              </select>
            </div>
            <div><label style={lbl}>{t("capacity")}</label><input style={{ ...inp, width: 90 }} type="number" value={vf.capacity} onChange={(e) => setVf({ ...vf, capacity: e.target.value })} /></div>
            <div><label style={lbl}>{t("rental")}</label><input style={{ ...inp, width: 110 }} type="number" value={vf.rental} onChange={(e) => setVf({ ...vf, rental: e.target.value })} /></div>
            <button className="btn primary small" onClick={submitVenue}>{t("addVenue")}</button>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {venues.map((v) => (
              <span key={v.id} style={{ border: "1px solid #e2e6ea", borderRadius: 8, padding: "5px 10px", fontSize: 13 }}>
                <b>{v.name}</b> <span className="muted">· {v.kind}{v.capacity ? ` · ${v.capacity} ${t("pax")}` : ""}</span>
                <span onClick={() => removeVenue(v)} style={{ marginLeft: 8, color: "#A32D2D", cursor: "pointer" }}>×</span>
              </span>
            ))}
            {venues.length === 0 && <span className="muted" style={{ fontSize: 13 }}>—</span>}
          </div>
        </div>
      )}

      {showForm && (
        <div style={{ ...CARD, padding: 14, marginTop: 12 }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 10 }}>
            <div style={{ ...cell, gridColumn: "1 / -1" }}><label style={lbl}>{t("title_f")}</label><input style={{ ...field, borderColor: err === "title" ? "#A32D2D" : "#d8dee2" }} value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></div>
            <div style={cell}><label style={lbl}>{t("type")}</label><select style={field} value={form.event_type} onChange={(e) => setForm({ ...form, event_type: e.target.value })}>{EVENT_TYPES.map((k) => <option key={k} value={k}>{k}</option>)}</select></div>
            <div style={cell}><label style={lbl}>{t("venue")}</label><select style={field} value={form.venue_id} onChange={(e) => setForm({ ...form, venue_id: e.target.value })}><option value="">—</option>{venues.map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}</select></div>
            <div style={cell}><label style={lbl}>{t("pkg")}</label><select style={field} value={form.package_id} onChange={(e) => { const pid = e.target.value; const p = packages.find((x) => String(x.id) === pid); setForm({ ...form, package_id: pid, rate_per_cover: p ? String(p.per_head_price) : form.rate_per_cover }); }}><option value="">{t("pkgNone")}</option>{packages.map((p) => <option key={p.id} value={p.id}>{p.name}{p.per_head_price ? ` (${p.per_head_price})` : ""}</option>)}</select></div>
            <div style={cell}><label style={lbl}>{t("date")}</label><input type="date" style={field} value={form.event_date} onChange={(e) => setForm({ ...form, event_date: e.target.value })} /></div>
            <div style={cell}><label style={lbl}>{t("start")}</label><input type="time" style={field} value={form.start_time} onChange={(e) => setForm({ ...form, start_time: e.target.value })} /></div>
            <div style={cell}><label style={lbl}>{t("end")}</label><input type="time" style={field} value={form.end_time} onChange={(e) => setForm({ ...form, end_time: e.target.value })} /></div>
            <div style={cell}><label style={lbl}>{t("covers")}</label><input type="number" style={field} value={form.covers} onChange={(e) => setForm({ ...form, covers: e.target.value })} /></div>
            <div style={cell}><label style={lbl}>{t("rate")}</label><input type="number" style={field} value={form.rate_per_cover} onChange={(e) => setForm({ ...form, rate_per_cover: e.target.value })} /></div>
            <div style={cell}><label style={lbl}>{t("deposit")}</label><input type="number" style={field} value={form.deposit} onChange={(e) => setForm({ ...form, deposit: e.target.value })} /></div>
            <div style={cell}><label style={lbl}>{t("company")}</label><select style={field} value={form.company_account_id} onChange={(e) => setForm({ ...form, company_account_id: e.target.value })}><option value="">{t("none")}</option>{companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select></div>
            <div style={cell}><label style={lbl}>{t("partOfGroup")}</label><select style={field} value={form.block_id} onChange={(e) => setForm({ ...form, block_id: e.target.value })}><option value="">{t("groupNone")}</option>{blocks.map((b) => <option key={b.id} value={b.id}>{blockLabel(b)}</option>)}</select></div>
            <div style={cell}><label style={lbl}>{t("contact")}</label><input style={field} value={form.contact_name} onChange={(e) => setForm({ ...form, contact_name: e.target.value })} /></div>
            <div style={cell}><label style={lbl}>{t("phone")}</label><input style={field} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
            <div style={cell}><label style={lbl}>{t("status")}</label><select style={field} value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>{STATUSES.map((k) => <option key={k} value={k}>{k}</option>)}</select></div>
          </div>
          {err && err !== "title" && <div style={{ color: "#A32D2D", fontSize: 12.5, marginTop: 8 }}>{err}</div>}
          <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
            <button className="btn primary" onClick={submitEvent}>{t("create")}</button>
            <button className="btn" onClick={() => { setShowForm(false); setForm(blankForm); }}>{t("cancel")}</button>
          </div>
        </div>
      )}

      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginTop: 14 }}>
        <label style={{ fontSize: 12, color: "#5f6b78" }}>{t("from")} <input type="date" style={{ ...inp, marginLeft: 4 }} value={from} onChange={(e) => setFrom(e.target.value)} /></label>
        <label style={{ fontSize: 12, color: "#5f6b78" }}>{t("to")} <input type="date" style={{ ...inp, marginLeft: 4 }} value={to} onChange={(e) => setTo(e.target.value)} /></label>
        <select style={inp} value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">{t("all")}</option>
          {STATUSES.map((k) => <option key={k} value={k}>{k}</option>)}
        </select>
      </div>

      {showBoard && (
        <div style={{ ...CARD, padding: 12, marginTop: 12, overflowX: "auto" }}>
          <table style={{ borderCollapse: "collapse", minWidth: 560 }}>
            <thead><tr>
              <th style={{ ...bhead, textAlign: "left", position: "sticky", left: 0, zIndex: 1 }}>{t("venue")}</th>
              {enumDays(from, to).map((d) => <th key={d} style={{ ...bhead, background: d === iso(0) ? "#E7F6EC" : "#F7FAF9" }}>{fmtDay(d)}</th>)}
            </tr></thead>
            <tbody>
              {[...venues, { id: null, name: t("unassigned") }].map((v) => (
                <tr key={v.id || "none"}>
                  <td style={{ ...bcell, fontWeight: 600, position: "sticky", left: 0, background: "#fff", zIndex: 1 }}>{v.name}</td>
                  {enumDays(from, to).map((d) => {
                    const evs = events.filter((e) => (e.venue_id || null) === (v.id || null) && e.event_date === d);
                    return (
                      <td key={d} style={{ ...bcell, background: d === iso(0) ? "#F3FBF6" : "#fff" }}>
                        {evs.map((e) => (
                          <div key={e.id} onClick={() => open(e.id)} title={`${e.title} · ${e.status}`}
                            style={{ cursor: "pointer", background: "#F1F5F4", borderLeft: `3px solid ${STATUS_COLOR[e.status] || "#5b6472"}`, borderRadius: 4, padding: "2px 4px", marginBottom: 2, fontSize: 11.5, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 110 }}>
                            {e.title}
                          </div>
                        ))}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: (!showBoard && sel) ? "1fr 1fr" : "1fr", gap: 14, marginTop: 12 }}>
        {!showBoard && (
        <div>
          {events.length === 0 ? <div className="muted" style={{ fontSize: 13, padding: 8 }}>{t("noEvents")}</div> : (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {events.map((e) => (
                <div key={e.id} onClick={() => open(e.id)} style={{ ...CARD, padding: 12, cursor: "pointer", borderColor: sel && sel.id === e.id ? "#0F6E56" : "#eef2f2" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                    <div style={{ fontWeight: 700 }}>{e.title}</div>
                    <span style={{ fontSize: 11.5, fontWeight: 700, textTransform: "uppercase", color: STATUS_COLOR[e.status] || "#5b6472" }}>{e.status}</span>
                  </div>
                  <div className="muted" style={{ fontSize: 12.5, marginTop: 3 }}>
                    {e.event_date}{e.start_time ? ` · ${e.start_time}` : ""} · {e.event_type}
                    {e.venue_name ? ` · ${e.venue_name}` : ""}{e.covers ? ` · ${e.covers} ${t("pax")}` : ""}
                  </div>
                  <div style={{ fontSize: 12.5, marginTop: 4 }}>
                    {t("balance")}: <b>{formatPrice(e.folio.balance, cur)}</b>
                    <span className="muted"> / {formatPrice(e.folio.total, cur)}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        )}

        {sel && (
          <div style={{ ...CARD, padding: 14, alignSelf: "start" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 15 }}>{sel.title}</div>
                <div className="muted" style={{ fontSize: 12.5 }}>{sel.event_date}{sel.start_time ? ` · ${sel.start_time}–${sel.end_time || ""}` : ""} · {sel.venue_name || "—"}</div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                {!editing && sel.status !== "cancelled" && <button className="btn secondary small" onClick={() => startEdit(sel)}>✎ {t("edit")}</button>}
                <span onClick={() => { setSel(null); setEditing(false); }} style={{ cursor: "pointer", color: "#5b6472", fontSize: 18 }}>×</span>
              </div>
            </div>

            {editing && (
              <div style={{ marginTop: 10, padding: 12, background: "#f7f9fa", borderRadius: 10, border: "1px solid #eef2f2" }}>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 8 }}>
                  <div style={{ ...cell, gridColumn: "1 / -1" }}><label style={lbl}>{t("title_f")}</label><input style={{ ...field, borderColor: err === "title" ? "#A32D2D" : "#d8dee2" }} value={eform.title} onChange={(e) => setEform({ ...eform, title: e.target.value })} /></div>
                  <div style={cell}><label style={lbl}>{t("type")}</label><select style={field} value={eform.event_type} onChange={(e) => setEform({ ...eform, event_type: e.target.value })}>{EVENT_TYPES.map((k) => <option key={k} value={k}>{k}</option>)}</select></div>
                  <div style={cell}><label style={lbl}>{t("venue")}</label><select style={field} value={eform.venue_id} onChange={(e) => setEform({ ...eform, venue_id: e.target.value })}><option value="">—</option>{venues.map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}</select></div>
                  <div style={cell}><label style={lbl}>{t("pkg")}</label><select style={field} value={eform.package_id} onChange={(e) => { const pid = e.target.value; const p = packages.find((x) => String(x.id) === pid); setEform({ ...eform, package_id: pid, rate_per_cover: p ? String(p.per_head_price) : eform.rate_per_cover }); }}><option value="">{t("pkgNone")}</option>{packages.map((p) => <option key={p.id} value={p.id}>{p.name}{p.per_head_price ? ` (${p.per_head_price})` : ""}</option>)}</select></div>
                  <div style={cell}><label style={lbl}>{t("date")}</label><input type="date" style={field} value={eform.event_date} onChange={(e) => setEform({ ...eform, event_date: e.target.value })} /></div>
                  <div style={cell}><label style={lbl}>{t("start")}</label><input type="time" style={field} value={eform.start_time} onChange={(e) => setEform({ ...eform, start_time: e.target.value })} /></div>
                  <div style={cell}><label style={lbl}>{t("end")}</label><input type="time" style={field} value={eform.end_time} onChange={(e) => setEform({ ...eform, end_time: e.target.value })} /></div>
                  <div style={cell}><label style={lbl}>{t("covers")}</label><input type="number" style={field} value={eform.covers} onChange={(e) => setEform({ ...eform, covers: e.target.value })} /></div>
                  <div style={cell}><label style={lbl}>{t("rate")}</label><input type="number" style={field} value={eform.rate_per_cover} onChange={(e) => setEform({ ...eform, rate_per_cover: e.target.value })} /></div>
                  <div style={cell}><label style={lbl}>{t("company")}</label><select style={field} value={eform.company_account_id} onChange={(e) => setEform({ ...eform, company_account_id: e.target.value })}><option value="">{t("none")}</option>{companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select></div>
                  <div style={cell}><label style={lbl}>{t("contact")}</label><input style={field} value={eform.contact_name} onChange={(e) => setEform({ ...eform, contact_name: e.target.value })} /></div>
                  <div style={cell}><label style={lbl}>{t("phone")}</label><input style={field} value={eform.phone} onChange={(e) => setEform({ ...eform, phone: e.target.value })} /></div>
                  <div style={cell}><label style={lbl}>{t("email")}</label><input style={field} value={eform.email} onChange={(e) => setEform({ ...eform, email: e.target.value })} /></div>
                  <div style={{ ...cell, gridColumn: "1 / -1" }}><label style={lbl}>{t("notes")}</label><input style={field} value={eform.notes} onChange={(e) => setEform({ ...eform, notes: e.target.value })} /></div>
                </div>
                <div style={{ marginTop: 8, display: "flex", gap: 8, alignItems: "center" }}>
                  <button className="btn primary small" onClick={saveEdit}>{t("save")}</button>
                  <button className="btn secondary small" onClick={() => { setEditing(false); setErr(""); }}>{t("cancel")}</button>
                  {err && err !== "title" && <span style={{ color: "#A32D2D", fontSize: 13 }}>{err}</span>}
                </div>
              </div>
            )}

            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", margin: "10px 0" }}>
              {STATUSES.map((st) => (
                <button key={st} onClick={() => setStatusOf(sel, st)}
                  style={{ padding: "4px 9px", borderRadius: 7, fontSize: 12, cursor: "pointer",
                    border: sel.status === st ? "1.5px solid #0F6E56" : "1px solid #e2e6ea",
                    background: sel.status === st ? "#E7F6EC" : "#fff", color: sel.status === st ? "#0F6E56" : "#5b6472" }}>
                  {st}
                </button>
              ))}
            </div>

            <div style={{ borderTop: "1px solid #eef2f2", paddingTop: 8, marginBottom: 6 }}>
              <label style={lbl}>{t("partOfGroup")}</label>
              <select style={{ ...inp, width: "100%" }} value={sel.block_id || ""} onChange={(e) => setBlockOf(sel, e.target.value)}>
                <option value="">{t("groupNone")}</option>
                {blocks.map((b) => <option key={b.id} value={b.id}>{blockLabel(b)}</option>)}
                {sel.block_id && !blockById(sel.block_id) && <option value={sel.block_id}>#{sel.block_id}</option>}
              </select>
              {sel.block_id && <div className="muted" style={{ fontSize: 12, marginTop: 3 }}>{t("consolidatedNote")}</div>}
            </div>

            {sel.package_name && (
              <div style={{ borderTop: "1px solid #eef2f2", paddingTop: 8, marginBottom: 2 }}>
                <div style={{ fontSize: 12.5 }}><b>{t("catering")}:</b> {sel.package_name}{sel.package_price ? ` · ${formatPrice(sel.package_price, cur)}/${t("pax")}` : ""}</div>
                {sel.package_definition && <div className="muted" style={{ fontSize: 12, marginTop: 2 }}>{t("included")}: {sel.package_definition}</div>}
              </div>
            )}

            <div style={{ borderTop: "1px solid #eef2f2", paddingTop: 10 }}>
              <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{t("folio")}</div>
              <table style={{ width: "100%", fontSize: 13, borderCollapse: "collapse" }}>
                <tbody>
                  <tr><td style={{ padding: "2px 0" }}>{t("coversTotal")} ({sel.covers} × {formatPrice(sel.rate_per_cover, cur)})</td><td style={{ textAlign: "right" }}>{formatPrice(sel.folio.covers_total, cur)}</td></tr>
                  <tr><td style={{ padding: "2px 0" }}>{t("extras")}</td><td style={{ textAlign: "right" }}>{formatPrice(sel.folio.extras, cur)}</td></tr>
                  {sel.folio.discount > 0 && <tr><td style={{ padding: "2px 0", color: "#A32D2D" }}>− {t("del")}</td><td style={{ textAlign: "right", color: "#A32D2D" }}>−{formatPrice(sel.folio.discount, cur)}</td></tr>}
                  <tr><td style={{ padding: "2px 0" }}>{t("service")}</td><td style={{ textAlign: "right" }}>{formatPrice(sel.folio.service_charge, cur)}</td></tr>
                  <tr><td style={{ padding: "2px 0" }}>{sel.folio.tax_label || t("tax")}</td><td style={{ textAlign: "right" }}>{formatPrice(sel.folio.tax_amount, cur)}</td></tr>
                  <tr style={{ borderTop: "1px solid #ddd", fontWeight: 700 }}><td style={{ padding: "3px 0" }}>{t("total")}</td><td style={{ textAlign: "right" }}>{formatPrice(sel.folio.total, cur)}</td></tr>
                  <tr><td style={{ padding: "2px 0", color: "#0F6E56" }}>{t("paid")}</td><td style={{ textAlign: "right", color: "#0F6E56" }}>{formatPrice(sel.folio.paid, cur)}</td></tr>
                  <tr style={{ fontWeight: 700 }}><td style={{ padding: "2px 0" }}>{t("balance")}</td><td style={{ textAlign: "right" }}>{formatPrice(sel.folio.balance, cur)}</td></tr>
                </tbody>
              </table>
            </div>

            <div style={{ borderTop: "1px solid #eef2f2", marginTop: 10, paddingTop: 10 }}>
              {(sel.charges || []).map((c) => (
                <div key={c.id} style={{ display: "flex", justifyContent: "space-between", fontSize: 12.5, padding: "2px 0" }}>
                  <span>{c.kind}{c.label ? ` · ${c.label}` : ""} {c.qty !== 1 ? `×${c.qty}` : ""}</span>
                  <span>{formatPrice(c.line, cur)} <span onClick={() => removeCharge(sel, c.id)} style={{ color: "#A32D2D", cursor: "pointer", marginLeft: 6 }}>×</span></span>
                </div>
              ))}
              <div style={{ display: "flex", gap: 6, marginTop: 8, alignItems: "flex-end", flexWrap: "wrap" }}>
                <select style={{ ...inp, width: 92 }} value={cf.kind} onChange={(e) => setCf({ ...cf, kind: e.target.value })}>{CHARGE_KINDS.map((k) => <option key={k} value={k}>{k}</option>)}</select>
                <input style={{ ...inp, width: 120 }} placeholder={t("label")} value={cf.label} onChange={(e) => setCf({ ...cf, label: e.target.value })} />
                <input style={{ ...inp, width: 52 }} type="number" placeholder={t("qty")} value={cf.qty} onChange={(e) => setCf({ ...cf, qty: e.target.value })} />
                <input style={{ ...inp, width: 90 }} type="number" placeholder={t("amount")} value={cf.amount} onChange={(e) => setCf({ ...cf, amount: e.target.value })} />
                <button className="btn primary small" onClick={() => submitCharge(sel)}>{t("addCharge")}</button>
              </div>
            </div>

            <div style={{ marginTop: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <button className="btn" onClick={() => printBeo(sel)}>{t("printBeo")}</button>
              <button className="btn" style={{ color: "#A32D2D" }} onClick={() => removeEvent(sel)}>{t("delEvent")}</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
